import { Navigate, Outlet } from 'react-router-dom';
import { useEffect, useState, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { checkAuth } from 'Api/userapi';

const PublicRoutes = () => {
  const [isAuthenticated, setIsAuthenticated] = useState<boolean | null>(null);
  const dispatch = useDispatch();
  const hasCheckedAuth = useRef(false);

  useEffect(() => {
    const verifyAuth = async () => {
      try {
        await checkAuth(dispatch);
        setIsAuthenticated(true);
      } catch (error) {
        // console.error('Authentication failed', error);
        setIsAuthenticated(false);
      }
    };

    if (!hasCheckedAuth.current) {
      hasCheckedAuth.current = true;
      verifyAuth();
    }
  }, [dispatch]);

  if (isAuthenticated === null) {
    return <div>Loading...</div>;
  }

  return isAuthenticated ? <Navigate to="/dashboard/properties" /> : <Outlet />;
};

export default PublicRoutes;
